<template>
  <div>
    <canvas id="linechart"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";

export default {
  props: {
    chartType: { type: String, default: "line" },
    chartData: { type: Object, default: null },
    chartOptions: { type: Object, default: null },
  },
  created() {
    this.data.labels = this.labels;
  },
  data() {
    return {
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],

      data: {
        labels: [],
        datasets: [
          {
            label: "Active Users",
            data: [200, 250, 335, 455, 575, 600, 662],
            fill: false,
            borderColor: "rgb(75, 192, 192)",
            tension: 0.1,
          },
        ],
      },
    };
  },
  mounted() {
    let { chartType, chartData, chartOptions } = this;
    this.chartConstructor(chartType, this.datasets);
  },
  methods: {
    chartConstructor(chartType, chartData) {
      const chartElement = document.getElementById("linechart");
      new Chart(chartElement, {
        type: "line",
        data: this.data,
      });
    },
  },
};
</script>
